import styled from "styled-components";
import * as theme from "theme";

import UnlockSubscriptionImage from "statics/img/unlock-icon-in-computer.svg";

const TemplateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const BodyDiv = styled(TemplateWrapper)`
  padding: 0 24px 12px 24px;
  max-width: 660px;
  .main-title {
    font-size: 24px;
  }
  .subscription-image {
    width: 104px;
    height: 116px;
    background-image: url(${UnlockSubscriptionImage});
    background-repeat: no-repeat;
    background-size: contain;
  }
  .list-box {
    border: 1px solid ${theme.palette.wolfGrey};
    border-radius: 4px;
    padding: 24px;
    margin: 0 16px;
    gap: 16px;
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 560px;
    .list-item {
      flex-direction: row;
      align-items: start;
      gap: 16px;
    }
    .description {
      line-height: 20px;
      margin-left: 30px;
    }
  }
`;

export const ButtonsDiv = styled(TemplateWrapper)`
  width: 100%;
  margin-bottom: 12px;
  .pricing-redirect {
    border: 0;
    background-color: transparent;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    color: ${theme.palette.gunmetal};
    text-decoration: none;
  }
`;

export const IconForList = styled.div`
  background-image: ${(props) =>
    props.iconUrl ? `url(${props.iconUrl})` : "none"};
  width: 24px;
  height: 24px;
  min-width: 24px;
`;

export const CenteredTitle = styled.div`
  width: 100%;
  text-align: center;
`;

export const SubscriptionPlaceholder = styled(TemplateWrapper)`
  justify-content: center;
  width: 100%;
  height: 40px;
  background-color: ${theme.palette.lightPastelBlue};
  color: ${theme.palette.tealBlue};
`;
